import React, { useEffect, useMemo } from 'react'
import { isEmpty, pick } from 'lodash-es'
import { getQuery } from '@vt/utils'
import { newLoginTypeTpls } from '@vt/apis/lib-ex'
import { useUserInfoSWR } from '../swrs/users/use-user-config'
import useProjectStore from '../project/use-project-store'

import Context from './context'

export default function ({
  children,
  AuthFailedComponent,
  onAuthFailed,
  alwaysShowChildren,
}) {
  // const [userInfo, setUserInfo] = useState({})
  const { token, setUserInfo, userInfo, getVtProject } = useProjectStore((s) =>
    pick(s, ['token', 'setUserInfo', 'userInfo', 'getVtProject'])
  )
  const vtProject = getVtProject()
  // const [isUpdate, setUpdate] = useState(false)
  console.log('[AUTH]: 获取到token', token)
  const { key, tpl, appId } = getQuery()

  // 是否请求新增的接口
  const isNormal =
    newLoginTypeTpls.includes(key) || newLoginTypeTpls.includes(tpl)

  const {
    userInfo: currentUserInfo,
    isUserLoading,
    fetchUserInfoError,
    // userInfoMutate,
  } = useUserInfoSWR(token, isNormal, appId)

  const saveUserInfo = (data) => {
    setUserInfo(data)
  }

  const afterLogout = () => {
    // clearToken
    vtProject.deleteStorage()
    // clearUserInfo
  }

  // if (!userInfo) {
  //   return <div>没有 userinfo {token}</div>
  // }

  const afterLogin = () => {
    // setUpdate(false)
  }

  useEffect(() => {
    if (!isEmpty(currentUserInfo)) {
      saveUserInfo(currentUserInfo)
    }
  }, [currentUserInfo])

  const values = useMemo(
    () => ({
      userInfo,
      token,
      afterLogin,
      afterLogout,
    }),
    []
  )

  // useEffect(() => {
  if ((!token || fetchUserInfoError) && onAuthFailed) {
    vtProject.deleteStorage()
    return onAuthFailed()
  }

  // }, [token, fetchUserInfoError, onAuthFailed])

  if ((!token || fetchUserInfoError) && AuthFailedComponent) {
    vtProject.deleteStorage()
    return AuthFailedComponent
  }

  if ((isUserLoading || fetchUserInfoError) && !alwaysShowChildren) {
    return null
    // setUpdate(false)
    // getUserInfo()
  }

  return <Context.Provider value={values}>{children}</Context.Provider>
}
